/** The role editor's column headings, also used to label a basic key anywhere it's named. */
export const BASIC_ACTION_LABELS = {
    view: 'View',
    edit: 'Create & edit',
    delete: 'Delete',
};
//# sourceMappingURL=basic-action-labels.js.map